import { Aboutme, Footer} from '../container';
import PageHero from "../components/PageHero/PageHero";
import aboutBg from "../assets/bgimage.jpg";
import Team from '../components/Team/Team';
import { SocialMedia } from '../components';

export default function AboutPage() {
  return <>
  <PageHero title="About" bgImage={aboutBg} />
  <Team/>
  <SocialMedia />
  <Aboutme />
  <Footer/></>;
}
